import { Component, Input } from '@angular/core';
import { RevisionNotice } from 'src/app/model/api/revision-notice';
import { TableSection } from 'src/app/model/shared/table-section';

import { documentToHtmlString } from '.';
import { IagRevisionNoticeTable } from 'src/app/model/section/iag-portal-revision-notice-table-setion';

@Component({
  selector: 'app-table-section',
  templateUrl: './table-section.component.html',
  styleUrls: ['./table-section.component.scss']
})
export class TableSectionComponent {
  @Input() tableSections: TableSection[] = [];
  @Input() apiProductUpdates: RevisionNotice[] = [];
  @Input() apiProductUpdatesTitle: string = '';
  @Input() isHomePage: boolean = false;
  @Input() iagProductUpdate: IagRevisionNoticeTable[] = [];
  @Input() iagProductUpdatesTitle: string = '';
  @Input() isIagPotalPage:boolean = false;
  @Input() isFileAssetsPage: boolean = false;
  @Input() isRevisionNoticesPage: boolean = false;
  @Input() isAPIReference: boolean = false;
  @Input() isPaymentsNdcCommercialFaqPage: boolean = false;

  constructor() {}

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }
}
